export const DATA_TYPES = {
    STATIC: 'STATIC',
    DATE: 'DATE',
    TEXT: 'TEXT',
    NUMERIC: 'NUMERIC',
    SELECT: 'SELECT',
    MULTI_SELECT: 'MULTI_SELECT',
    URL: 'URL',
};

export enum COLUMN_TYPES {
    STRING = 'STRING',
    WEBSITE = 'WEBSITE',
    DATE = 'DATE',
    DOUBLE = 'DOUBLE',
    SELECT = 'SELECT',
}

export enum ColumnValueTypes {
    STRING = 'STRING',
    DOUBLE_COLUMN_VALUE = 'DOUBLE_COLUMN_VALUE',
    USER_DEFINED_SELECT = 'USER_DEFINED_SELECT',
    DATE = 'DATE',
}

export const DEFAULT_DATA = {
    value: null,
    error: null,
    busy: false,
    editMode: false,
    selected: false,
    active: false,
    locale: null,
    relation: null,
    tooltip: null,
    options: null,
    collaboration: null,
};
